import { RouteType } from '@/types/types';
import SearchPage from '../components/Search/SearchPage';
import AssetInfo from '../components/Assets/AssetInfo';
import AssetTable from '../components/Assets/AssetTable';

export const routes: RouteType[] = [
  { index: true, path: '/:siteId', title: 'Index', element: SearchPage },
  {
    path: '/:siteId/search',
    title: 'Search',
    element: SearchPage,
  },
  {
    path: '/:siteId/assets',
    title: 'Assets',
    element: AssetTable,
  },
  {
    path: '/:siteId/assets/:assetUuid',
    title: 'Asset Details',
    element: AssetInfo,
  },
];
